import React, { createContext, type ReactNode, useContext } from 'react'
import preferenceKeys from '../person-page/preference-keys'
import type { ProviderValue } from './PreferenceProvider'
import PreferenceProvider from './PreferenceProvider'

type ConclusionDetailedViewOptions = {
  factsExpanded: boolean
  vitalsExpanded: boolean
}
type ConclusionDetailedViewValue = ProviderValue<ConclusionDetailedViewOptions>

const defaultValue = { factsExpanded: false, vitalsExpanded: false }

const ConclusionDetailedViewContext = createContext<ConclusionDetailedViewValue>([defaultValue, () => undefined])

export function useConclusionDetailedView(): ConclusionDetailedViewValue {
  return useContext(ConclusionDetailedViewContext)
}

type Props = {
  children: ReactNode
}

export default function ConclusionDetailedViewProvider({ children }: Props): JSX.Element {
  return (
    <PreferenceProvider
      preferenceKey={preferenceKeys.CONCLUSION_DETAILED_VIEW}
      Context={ConclusionDetailedViewContext}
      defaultValue={defaultValue}
    >
      {children}
    </PreferenceProvider>
  )
}
